import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PlatiBlocariAutoComponent } from './plati-blocari-auto.component';

const routes: Routes = [
    {
        path: '',
        component: PlatiBlocariAutoComponent,
        data: {
            title: 'Plati Deblocare Auto'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PlatiBlocariAutoRoutingModule { }
